import { Injectable } from '@angular/core';
import { CreNgConfig } from 'cre-ng';

@Injectable({
  providedIn: 'root'
})
export class AppDataService {
  redirectToPortal: boolean;
  ticket: string;

  constructor(private config: CreNgConfig) { }

  getCallbackUrl(): string {
    return localStorage.getItem(`cre_${this.config.sessionAppName}_callbackUrl`);
  }

  getOriginId(): string {
    return localStorage.getItem(`cre_${this.config.sessionAppName}_originId`);
  }

  getSelectedState(): string {
    return localStorage.getItem(`cre_${this.config.sessionAppName}_stateCode`);
  }

  getTaskId(): string {
    return localStorage.getItem(`cre_${this.config.sessionAppName}_taskId`);
  }

  getUsername(): string{
    return localStorage.getItem(`cre_${this.config.sessionAppName}_username`);
  }

  getUserToken(): string {
    return localStorage.getItem(`cre_${this.config.sessionAppName}_auth`);
  }

  setCallbackUrl(url: string) {
    if (url  && url !== '') {
      localStorage.setItem(`cre_${this.config.sessionAppName}_callbackUrl`, url);
    }
  }

  setOriginId(originId: string) {
    if (originId && originId !== '') {
      localStorage.setItem(`cre_${this.config.sessionAppName}_originId`, originId);
    }
  }

  setRedirectToPortal(redirectToPortal: boolean): void {
    this.redirectToPortal = redirectToPortal;
  }

  setSelectedState(stateCode: string) {
    if (stateCode && stateCode !== '') {
      localStorage.setItem(`cre_${this.config.sessionAppName}_stateCode`, stateCode);
    }
  }

  setTaskId(taskId: string) {
    if (taskId && taskId !== '') {
      localStorage.setItem(`cre_${this.config.sessionAppName}_taskId`, taskId);
    }
  }

  setUsername(username: string) {
    if (username && username !== '') {
      localStorage.setItem(`cre_${this.config.sessionAppName}_username`, username);
    }
  }
}
